/** Navegação persistente do prestador: somente contexto de tela, nunca autorização. */
export type PortalTab = 'home' | 'orders' | 'agenda' | 'stock' | 'profile';
const TABS: PortalTab[] = ['home', 'orders', 'agenda', 'stock', 'profile'];
// 'active' e 'late' permanecem para atalhos internos; filtros removidos caem em 'scheduled'.
const PRESETS = ['active', 'today', 'scheduled', 'late', 'in_progress', 'done'];
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Descarta parâmetros inesperados e datas inexistentes antes de compor a navegação. */
export function readPortalNavigation(params: URLSearchParams) {
  const tab = params.get('tab') as PortalTab;
  const order = params.get('order') ?? '';
  const preset = params.get('filter') ?? '';
  const date = params.get('date') ?? '';
  const validDate = /^\d{4}-\d{2}-\d{2}$/.test(date) && !Number.isNaN(Date.parse(date)) && new Date(date).toISOString().slice(0, 10) === date;
  return {
    tab: TABS.includes(tab) ? tab : 'home' as PortalTab,
    orderId: UUID.test(order) ? order : null,
    preset: PRESETS.includes(preset) ? preset : 'scheduled',
    date: validDate ? date : null,
  };
}

/** Reconstrói destino no tenant atual; nenhum endereço externo é aceito. */
export function providerInspectionReturnPath(tenantSlug: string, params: URLSearchParams): string {
  const context = readPortalNavigation(params);
  const safe = new URLSearchParams({ tab: context.orderId ? context.tab : 'orders', filter: context.preset });
  if (context.orderId) safe.set('order', context.orderId);
  if (context.date) safe.set('date', context.date);
  return `/prestador/${encodeURIComponent(tenantSlug)}?${safe}`;
}